interface Permissions {
    view: boolean;
    admin: boolean;
}

export function checkPermissions(roleIds: number[]): Permissions {
    const adminRoles = new Set([1, 5, 7]);
    const viewerRoles = new Set([4, 6]);

    const hasAdmin = roleIds.some(id => adminRoles.has(id));

    const hasView = roleIds.some(id => viewerRoles.has(id) || hasAdmin);

    return { view: hasView, admin: hasAdmin };
}